import { createMuiTheme } from '@material-ui/core/styles';
import { grey } from '@material-ui/core/colors';
import zIndex from '@material-ui/core/styles/zIndex';

const drawerWidth = 200;
export const THEME = createMuiTheme({
  palette: {
    primary: {
      light: grey[800],
      main: grey[900],
      dark: grey[400],
      contrastText: grey[50],
    },
    secondary: {
      main: "#77bf43",
      contrastText: grey[50],
    }
  },
});
THEME.overrides = {
  MuiAppBar: {
    colorPrimary: {
      backgroundColor: THEME.palette.primary.main
    },
    root: {
      zIndex: zIndex.drawer + 1
    }
  },
  MuiDrawer: {
    root: {
      width: drawerWidth,
      flexShrink: 0,
    },
    paper: {
      width: drawerWidth,
      backgroundColor: THEME.palette.primary.main,
    }
  },
  MuiIconButton: {
    root: {
      color: THEME.palette.secondary.main,
    }
  },
  MuiTableCell: {
    head: {
      color: THEME.palette.primary.contrastText,
      backgroundColor: THEME.palette.primary.main,
    },
    body: {
      color: THEME.palette.primary.main,
      backgroundColor: THEME.palette.primary.contrastText,
    }
  },
  MuiButton: {
    root: {
      color: THEME.palette.secondary.main,
    }
  }
}

export const DARK_THEME = createMuiTheme({
  palette: {
    background: {
      default: grey[800]
    },
    primary: {
      light: grey[800],
      main: grey[900],
      contrastText: grey[50],
    },
    secondary: {
      main: "#77bf43",
      contrastText: grey[50],
    },
  },
});
DARK_THEME.overrides = {
  MuiContainer: {
    root: {
      backgroundColor: DARK_THEME.palette.primary.main,
    }
  },
  MuiAppBar: {
    colorPrimary: {
      backgroundColor: THEME.palette.primary.main
    },
    root: {
      zIndex: zIndex.drawer + 1
    }
  },
  MuiAvatar: {
    colorDefault: {
      backgroundColor: DARK_THEME.palette.secondary.main,
    }
  },
  MuiTypography: {
    root: {
      color: DARK_THEME.palette.primary.contrastText
    }
  },
  MuiIconButton: {
    root: {
      color: DARK_THEME.palette.secondary.main,
    }
  },
  MuiLink: {
    root: {
      color: DARK_THEME.palette.secondary.main,
    }
  },
  MuiTextField: {
    root: {
      backgroundColor: DARK_THEME.palette.primary.contrastText,
    }
  }
}